module.exports = __webpack_public_path__ + "img/biaoqian_chuanbo.002ce87a.png";